import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa15745c&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa15745c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa15745c')) {
      api.createRecord('aa15745c', component.options)
    } else {
      api.reload('aa15745c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aa15745c&scoped=true", function () {
      api.rerender('aa15745c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/cdkey/index.vue"
export default component.exports